import Typography from 'antd/es/typography';
import styled from 'styled-components';

export const LoginOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const PasswordSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
`;

export const MagicLinkSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

export const LoginMethodContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 0 auto;

  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item {
    margin-bottom: 16px;
  }

  a {
    color: ${({ theme }) => theme.token.colorPrimary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ChangeLink = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.token.colorPrimary};
  cursor: pointer;
  padding: 0;
  font-size: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubText = styled(Typography.Text)`
  color: ${({ theme }) => theme.token.colorTextSecondary};
  margin-bottom: 16px;
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;
